module.exports = __webpack_public_path__ + "franchise-watch_dogs-mobile.png";